// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page .about-card {
  max-width: 720px;
  margin: 0 auto;
}

.about-title {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.about-body {
  text-align: left;
  line-height: 1.65;
}

.about-paragraph {
  color: var(--text-secondary, #a1a1aa);
  font-size: 0.95rem;
  margin: 0 0 1rem;
}

.about-subheading {
  color: var(--text-primary, #fafafa);
  font-size: 1.05rem;
  font-weight: 600;
  margin: 1.25rem 0 0.75rem;
}

.about-links {
  list-style: none;
  padding: 0;
  margin: 0 0 1rem;
}

.about-links li {
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
  color: var(--text-secondary, #a1a1aa);
  word-break: break-word;
}

.about-link-label {
  color: var(--text-primary, #fafafa);
  font-weight: 500;
}

.about-inline-link {
  color: var(--accent, #60a5fa);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.about-inline-link:hover {
  opacity: 0.9;
}

.about-phones {
  list-style: none;
  padding: 0;
  margin: 0;
}

.about-phones li {
  margin-bottom: 0.35rem;
}

.about-phone-link {
  color: var(--accent, #60a5fa);
  font-size: 1rem;
  text-decoration: none;
}

.about-phone-link:hover {
  text-decoration: underline;
}

.about-loading {
  text-align: center;
  color: var(--text-secondary, #a1a1aa);
  padding: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/About.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf","sourcesContent":[".about-page .about-card {\r\n  max-width: 720px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.about-title {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.about-body {\r\n  text-align: left;\r\n  line-height: 1.65;\r\n}\r\n\r\n.about-paragraph {\r\n  color: var(--text-secondary, #a1a1aa);\r\n  font-size: 0.95rem;\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n.about-subheading {\r\n  color: var(--text-primary, #fafafa);\r\n  font-size: 1.05rem;\r\n  font-weight: 600;\r\n  margin: 1.25rem 0 0.75rem;\r\n}\r\n\r\n.about-links {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0 0 1rem;\r\n}\r\n\r\n.about-links li {\r\n  margin-bottom: 0.5rem;\r\n  font-size: 0.95rem;\r\n  color: var(--text-secondary, #a1a1aa);\r\n  word-break: break-word;\r\n}\r\n\r\n.about-link-label {\r\n  color: var(--text-primary, #fafafa);\r\n  font-weight: 500;\r\n}\r\n\r\n.about-inline-link {\r\n  color: var(--accent, #60a5fa);\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n}\r\n\r\n.about-inline-link:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n.about-phones {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.about-phones li {\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.about-phone-link {\r\n  color: var(--accent, #60a5fa);\r\n  font-size: 1rem;\r\n  text-decoration: none;\r\n}\r\n\r\n.about-phone-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.about-loading {\r\n  text-align: center;\r\n  color: var(--text-secondary, #a1a1aa);\r\n  padding: 2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
